import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { API_QUERY_KEYS, GetSortOptionsResponse, QueryDefaults, getSortOptions } from 'api';

export const useSortOptions = (): UseQueryResult<GetSortOptionsResponse> => {
  return useQuery([API_QUERY_KEYS.getSortOptions], () => getSortOptions(), {
    ...QueryDefaults,
    onSuccess: (data: GetSortOptionsResponse) => {
      return data?.sortOptions;
    },
    onError: (error: unknown) => {
      if (error) {
        return [];
      }
    },
  });
};
